import { Component, Input, OnInit, AfterViewInit, OnDestroy } from "@angular/core";

@Component({
  selector: "debug-panel",
  templateUrl: "./debug-panel.component.html",
  styleUrls: ["./debug-panel.component.css"],
})
export class DebugPanelComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() screenType: string = "desktop";

  width = window.innerWidth;
  height = window.innerHeight;
  zoom = 100;
  devicePixelRatio = window.devicePixelRatio;
  devicePixelRatioPercent = Math.round(this.devicePixelRatio * 100);

  listFrameWidth = 0;
  detailFrameWidth = 0;

  private intervalId: any;
  private testElement!: HTMLElement;

  ngOnInit(): void {
    // Cria elemento de referência para medir zoom aproximado
    this.testElement = document.createElement("div");
    this.testElement.style.width = "100px";
    this.testElement.style.height = "0";
    this.testElement.style.position = "absolute";
    this.testElement.style.visibility = "hidden";
    document.body.appendChild(this.testElement);

 
    this.intervalId = setInterval(() => this.updateDebugValues(), 200);
  }

  ngAfterViewInit(): void {

    setInterval(() => this.updateSizes(), 200);
  }

  ngOnDestroy(): void {
    if (this.intervalId) clearInterval(this.intervalId);
    if (this.testElement && this.testElement.parentElement)
      this.testElement.parentElement.removeChild(this.testElement);
  }

  private updateDebugValues() {
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    const rectWidth = this.testElement.getBoundingClientRect().width;
    this.zoom = Math.round((100 / rectWidth) * 100);

    this.devicePixelRatio = window.devicePixelRatio;
    this.devicePixelRatioPercent = Math.round(this.devicePixelRatio * 100);

    this.updateSizes();
  }
  private updateSizes() {
    const list = document.querySelector(".list-frame") as HTMLElement;
    const details = document.querySelector(".details-frame") as HTMLElement;

    this.listFrameWidth = list?.offsetWidth || 0;
    this.detailFrameWidth = details?.offsetWidth || 0;
  }
}
